import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { PillarProgressItem } from './PillarProgressItem';

export const PillarProgressItems = ({ collection: itemsCollection }) => {
  const isMobile = useMobileLayout();
  return (
    <FDStack justifyContent={'space-between'}>
      <span style={{ position: 'relative' }}>
        <FDStack spacing={isMobile ? 2 : 4} alignItems={'center'} justifyContent={'space-between'}>
          <span style={{
            borderTop: '1px dashed #fff',
            left: 8,
            right: 8,
            position: 'absolute',
          }}
          />
          {itemsCollection.resources().list().map((resource) => {
            return <PillarProgressItem resource={resource} key={resource.id()} />;
          })}
        </FDStack>
      </span>
      <div />
    </FDStack>

  );
};

PillarProgressItems.defaultProps = {
};

PillarProgressItems.propTypes = {
  collection: PropTypes.object.isRequired,
};
